import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";

import { IListItem } from '@nkr/models/index';
import { Modal, FormControl, Label, Button, Row, Col, Table, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import Loader from 'react-spinners/ClockLoader';
import { RecipientShieldIntervalType, RecipientShieldResultType } from '@nkr/enums/index';
import { IApplicationState, AppActionCreators, IAppState, RecipientShieldActionCreators, RecipientActionCreators, IRecipientShieldLookupResponse } from '@nkr/store/index';
import { IRecipientShieldEnrollmentsResponse, IRecipientShieldEnrollment, IRecipientShieldResult } from '@nkr/store/recipient-shield';
import { AgGridReact } from 'ag-grid-react';
import { ColumnApi, GridApi, ValueGetterParams, GridReadyEvent, FirstDataRenderedEvent, IHeaderParams, ColDef, ICellRendererParams } from 'ag-grid-community';

import { GridWrapper, HeaderWrapper } from '../styles';

import SortableHeaderComponent from './sortable-header';
import { IBaseResponse } from '@nkr/models/base-response';

interface IProps {
    centerId: number,
    isSuperUser: boolean,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getPendingEnrollments: (centerId: number, isSuperUser: boolean) => Promise<IRecipientShieldEnrollmentsResponse>,
    getResultFiles: (centerId: number, resultId) => Promise<IBaseResponse>,
    getRecipientShieldLookup: (resultId) => Promise<IRecipientShieldLookupResponse>

}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    [index: string]: string | boolean | number | IRecipientShieldEnrollment[] | any[] | { show: boolean, data: IRecipientShieldEnrollment } | { resultId: number, resultType: string, show: boolean }
    list: IRecipientShieldEnrollment[],
    filteredList: IRecipientShieldEnrollment[],
    testTypes: IListItem[],
    modal: {
        show: boolean,
        data: IRecipientShieldEnrollment
    },
    displayModal: {
        resultId: number,
        resultType: string,
        show: boolean
    }
}

class RecipientShieldList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        filteredList: [],
        testTypes: [],
        modal: {
            show: false,
            data: null
        },
        displayModal: {
            resultId: 0,
            resultType: "",
            show: false
        }
    }

    gridApi: GridApi;
    columnApi: ColumnApi;
    container: HTMLDivElement;
    intervalId: any;

    onGridReady = (params: GridReadyEvent) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
    }

    onDataFirstRendered = (params: FirstDataRenderedEvent) => {
        this.gridApi.sizeColumnsToFit();
    }

    onGridSizeChanged = () => {
        // get the current grids width
        var grid = document.getElementById('grid-wrapper');

        if (grid == null)
            return;

        var gridWidth = grid.offsetWidth;

        // keep track of which columns to hide/show
        var columnsToShow = [];
        var columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        var totalColsWidth = 0;
        var allColumns = this.columnApi.getAllColumns();

        for (var i = 0; i < allColumns.length; i++) {
            var column = allColumns[i];

            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        this.columnApi.setColumnsVisible(columnsToShow, true);
        this.columnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        this.gridApi.sizeColumnsToFit();
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    componentDidMount = () => {
        this.getData(true);
    }

    handleCloseModal = () => {
        this.setState({
            modal: {
                show: false,
                data: this.state.modal.data,
            },
            displayModal: {
                show: this.state.displayModal.show,
                resultId: this.state.displayModal.resultId,
                resultType: this.state.displayModal.resultType
            }
        });
    }

    handleCloseDisplayModal = () => {
        this.setState({
            modal: {
                show: this.state.modal.show,
                data: this.state.modal.data,
            },
            displayModal: {
                show: false,
                resultId: 0,
                resultType: this.state.displayModal.resultType
            }
        });
    }

    handleModalOpen = (data: IRecipientShieldEnrollment) => {
        this.setState({
            modal: {
                show: true,
                data: data
            }
        });
    }

    handleModalBigOpen = (result: IRecipientShieldResult) => {
        this.setState({
            modal: {
                show: true,
                data: this.state.modal.data
            },
            displayModal: {
                resultId: result.id,
                resultType: RecipientShieldResultType[result.type],
                show: true
            }
        });
    }

    getData = (message: boolean) => {
        //let user = q.user != null ? parseInt(q.user) : -2;
        let start = message ? this.props.showLoading('Getting enrollments, one moment please...') : Promise.resolve(null);

        start.then(() => {
            this.setState({
                fetching: message == true ? false : true
            }, () => {
                Promise.all([
                    this.props.getPendingEnrollments(this.props.centerId, this.props.isSuperUser),
                    this.props.getRecipientShieldLookup(this.props.centerId)
                ])
                    .then(([listResponse, lookupResponse]) => {

                        if (listResponse.data.success) {
                            let list = listResponse.data.results;

                            this.setState({
                                list,
                                filteredList: list,
                                fetching: false,
                                testTypes: lookupResponse.data.results.testTypes,
                                defaultTestCycles: lookupResponse.data.results.testTypes
                            }, () => {

                                if (this.gridApi != null) {
                                    this.gridApi.refreshCells();
                                }

                                this.updateFilter(1);
                            });
                        }

                        this.props.hideLoading();
                    });
            });
        });
    }

    dateComparator = (date1: string, date2: string) => {
        if (date1 === null && date2 === null)
            return 0;

        if (date1 === null)
            return -1;

        if (date2 === null)
            return 1;

        var date1Number = parseInt(moment(date1).format('YYYYMMDD'));
        var date2Number = parseInt(moment(date2).format('YYYYMMDD'));

        return date1Number - date2Number;
    }

    handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    columns: ColDef[] = [
        {
            colId: '1',
            field: 'rank',
            headerName: 'Rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <div>Rank</div>,
            sortable: false,
            width: 100,
            pinned: 'left',
            pinnedRowCellRendererFramework: () => <div></div>,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },

        {
            field: 'patientAlias',
            headerName: 'Patient Alias',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Patient<br />Alias</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100
        },

        {
            field: 'firstName',
            headerName: 'First Name',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>First<br />Name</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100
        }, {
            field: 'lastName',
            headerName: 'Last Name',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Last<br />Name</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100
        },

        {
            field: 'typeId',
            headerName: 'Type',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Type</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 200,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IRecipientShieldEnrollment;

                //get types
                var type = this.state.testTypes.find(x => x.value == data.orderTypeId.toString());
                //get name of TypeId

                return <Label>{type.description}</Label>;
            }
        },

        {
            field: 'status',
            headerName: 'status',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Status</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IRecipientShieldEnrollment;

                //get types
                var totalResults = data.results.length;
                var results = data.results.reduce((a, v) => a = a + (v.id > 0 ? 1 : 0), 0);
                //get name of TypeId

                if (results < totalResults && data.dateOrdered != null)
                    return <Label bsStyle="info">In Progress ({results}/{totalResults})</Label>;
                else if(data.dateOrdered == null)
                    return <Label>Pending</Label>;

                return <Label bsStyle="success">Complete</Label>;
            }
        },
        {
            field: 'transplantDate',
            headerName: 'Transplant Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Transplant<br />Date</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 140,
            sortable: true,
            valueGetter: (props: ValueGetterParams) =>{
                let txpDate = moment(props.data.transplantDate);
                
                if(txpDate.isValid() && txpDate.format("YYYY") != "0001")
                {
                    return moment(props.data.transplantDate).format('MM/DD/YYYY');
                } else {
                    return "--";
                }
            },
            comparator: this.dateComparator
        },
        {
            field: 'date',
            headerName: 'Order Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Order<br />Date</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 140,
            sortable: true,
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.date).isValid()
                    ? moment(props.data.orderDate).format('MM/DD/YYYY')
                    : "",
            comparator: this.dateComparator
        },
        {
            field: 'monthInterval',
            headerName: 'Months After Transplant',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Months After<br />Transplant</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IRecipientShieldEnrollment;

                var str = "";
                switch (data.monthIntervals) {
                    case RecipientShieldIntervalType.ONE:
                        str = "1";
                        break;
                    case RecipientShieldIntervalType.THREE:
                        str = "3";
                        break;
                    case RecipientShieldIntervalType.SIX:
                        str = "6";
                        break;
                    case RecipientShieldIntervalType.TWELVE:
                        str = "12";
                        break;
                    case RecipientShieldIntervalType.EIGHTEEN:
                        str = "18";
                        break;
                    case RecipientShieldIntervalType.TWENTYFOUR:
                        str = "24";
                        break;
                }

                return <Label>{str + " Mo"}</Label>;
            },
            valueGetter: (props: ValueGetterParams) => {

                let tmp = props.data as IRecipientShieldEnrollment;
                return tmp.monthIntervals;
            }
        },

        {
            field: 'actions',
            headerName: 'Actions',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Actions</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IRecipientShieldEnrollment;

                if(data.dateOrdered != null)
                    return <Button onClick={() => this.handleModalOpen(data)}>View Results</Button>;
                
                return <span>N/A</span>
            }
        }
    ];

    updateFilter = (filterValue: number) => {

        var baseList = _.cloneDeep(this.state.list);

        var list = [];
        switch(filterValue)
        {
            case 1:
                //Pending
                list = baseList.filter(x => {

                    //get results count
                    var totalResults = x.results.length;
                    var results = x.results.reduce((a, v) => a = a + (v.id > 0 ? 1 : 0), 0);

                    if (results < totalResults && x.dateOrdered != null)
                        return x;
                })
                break;

            case 2: 
                //Complete
                list = baseList.filter(x => {

                    //get results count
                    var totalResults = x.results.length;
                    var results = x.results.reduce((a, v) => a = a + (v.id > 0 ? 1 : 0), 0);

                    if (results == totalResults && x.dateOrdered != null)
                        return x;
                })
                break;

            case 3:
                //Future Orders
                list = baseList.filter(x => {
                    if (x.dateOrdered == null)
                        return x;
                })
                break;
        }

        this.setState({
            filteredList: list
        });
    }

    render = () => {
        const list = this.state.filteredList;

        return (
            <>
                <div style={{ display: this.state.fetching ? 'flex' : 'none', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            {this.state.fetching && (
                                <>
                                    <div style={{ marginRight: 5 }}>Fetching Watr Requests...</div>
                                    <Loader size={20} color={'#a1a1a1'} />
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <MediaQuery minWidth={1023} style={{ padding: 0 }}>
                    <div ref={this.saveContainer}></div>
                    <div>
                        <h5>Filters:</h5>
                        <ButtonToolbar>
                            <ToggleButtonGroup type="radio" name="options"  defaultValue={1}>
                                <ToggleButton onClick={() => this.updateFilter(1)} value={1}>Pending</ToggleButton>
                                <ToggleButton onClick={() => this.updateFilter(2)} value={2}>Complete</ToggleButton>
                                <ToggleButton onClick={() => this.updateFilter(3)} value={3}>Future Orders</ToggleButton>
                            </ToggleButtonGroup>
                        </ButtonToolbar>
                    </div>
                    <hr style={{ marginTop: 5, marginBottom: 5 }} />

                    <GridWrapper id="grid-wrapper" className='container-fluid-max-sm ag-theme-bootstrap'>
                        <AgGridReact
                            onGridReady={this.onGridReady}
                            onGridSizeChanged={this.onGridSizeChanged}
                            onFirstDataRendered={this.onDataFirstRendered}
                            rowData={list}
                            headerHeight={45}
                            rowHeight={40}
                            suppressCellSelection={true}
                            rowStyle={{ overflow: 'visible', cursor: 'pointer' }}
                            columnDefs={this.columns}
                            noRowsOverlayComponentFramework={() => <div>No Recipient Shield Results found...</div>}
                        >
                        </AgGridReact>
                    </GridWrapper>

                    <div style={{ marginBottom: 5 }}>{list.length} of {this.state.list.length} records shown...</div>

                    <Modal bsSize='lg' show={this.state.modal.show} onHide={this.handleCloseModal}>
                        <Modal.Header>
                            <h4>Lab Results</h4>
                            {this.state.modal.data
                            &&
                                <h5>{this.state.modal.data.firstName + " " + this.state.modal.data.lastName}</h5>
                            }
                        </Modal.Header>

                        <Modal.Body>
                            <Row>
                                {this.state.modal.data
                                    &&
                                    <Col sm={12} md={12}>
                                        <Table striped bordered condensed hover>
                                            <thead>
                                                <tr>
                                                    <th>Rank</th>
                                                    <th>Name</th>
                                                    <th>Type</th>
                                                    <th>Code</th>
                                                    <th>Value</th>
                                                    <th>Date Received</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.modal.data.results.map((res, index) =>
                                                    <tr>
                                                        <td style={{ verticalAlign: "bottom", textAlign: "center", width: "10px" }}>{index + 1}</td>
                                                        <td style={{verticalAlign: "bottom"}}>{res.testName}</td>
                                                        <td style={{ verticalAlign: "bottom" }}>{RecipientShieldResultType[res.type]}</td>
                                                        <td style={{ verticalAlign: "bottom" }}>{res.code}</td>
                                                        <td style={{ verticalAlign: "bottom" }}>{res.value}</td>
                                                        <td style={{ verticalAlign: "bottom", textAlign: "center" }}>{res.date ? moment(res.date).format("MM/DD/YYYY") : "Pending"}</td>
                                                        <td>
                                                            {res.id > 0
                                                                && <>
                                                                    <Button bsSize="xsmall" style={{ width: '100%' }} onClick={() => this.handleModalBigOpen(res)}>View</Button>
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                }
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle={'primary'} onClick={() => this.handleCloseModal()}>Close</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.state.displayModal.show} bsSize="large" onHide={this.handleCloseDisplayModal}>
                        <Modal.Header>
                            <Row>
                                <Col sm={6} md={6}>
                                {this.state.modal.data
                                    && <h4>{this.state.modal.data.firstName + " " + this.state.modal.data.lastName}</h4>
                                }
                                    <h5>Result Type: {this.state.displayModal.resultType}</h5>
                                    
                                </Col>
                                <Col sm={6} md={6}>
                                    <Button bsStyle={'primary'} style={{ width: "100%" }} onClick={() => this.handleCloseDisplayModal()}>Return to Results</Button>
                                </Col>
                            </Row>
                        </Modal.Header>

                        <Modal.Body style={{ height: "90vh" }}>
                            <Row>
                                <iframe
                                    src={__API__ + `/center/${this.props.centerId}/recipient-shield/download/${this.state.displayModal.resultId}`}
                                    frameBorder="0"
                                    scrolling="auto"
                                    height="100%"
                                    width="100%"
                                    style={{ height: "85vh" }}></iframe>
                            </Row>
                        </Modal.Body>
                    </Modal>
                </MediaQuery>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getPendingEnrollments: (centerId, isSuperUser) => { return dispatch(RecipientShieldActionCreators.getPendingEnrollments(centerId, isSuperUser)); },
        getResultFiles: (centerId, resultId) => { return dispatch(RecipientShieldActionCreators.getResultFiles(centerId, resultId)); },
        getRecipientShieldLookup: (resultId) => { return dispatch(RecipientActionCreators.getRecipientShieldLookup(resultId)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(RecipientShieldList);